function escapeUnicode(source, shouldEscapePrintable) {
  const charsToReplace = /[\s\S]/g;
  const isPrintable = /[\x20-\x7E]/;
  return source.replace(charsToReplace, (char) => {
    if (!shouldEscapePrintable && isPrintable.test(char)) {
      return char;
    }
    return `\\u${`000${char.charCodeAt(0).toString(16)}`.slice(-4)}`;
  });
}
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  escapeUnicode
};
//# sourceMappingURL=escapeUnicode.js.map
